<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('baseInfo.rateManagement.setRateCacheRange')"
    :width="$selectByLang('450px', '450px', '740px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('90px', '90px', '130px')" label-position="left">
      <el-form-item class="margin-Right50">
        {{ $t('baseInfo.rateManagement.setRateCacheRangePrefix') }} <el-input-number v-model="form.monthRange" :no="'monthRange'" style="width: 120px;" controls-position="right" :max="36" :min="18" :precision="0" /> {{ $t('baseInfo.rateManagement.setRateCacheRangeSuffix') }}
      </el-form-item>
      <el-form-item class="margin-Right50">
        <i class="el-icon-warning orange" />
        {{ $t('baseInfo.rateManagement.setRateCacheRangeNote') }}
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getRateCacheRange, saveRateCacheRange } from '@/api/rate'
import { syncSpecificBasicData, updateSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'RateCacheRangeDialog',
  components: {},
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      baseForm: {
        monthRange: 18
      },
      form: {
        monthRange: 18
      },
      hasUpdate: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.initData()
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        if (this.hasUpdate) {
          this.$emit('callback')
        }
      }
    }
  },
  methods: {
    initData() {
      getRateCacheRange().then(res => {
        if (res.ok) {
          const data = res.data
          if (data && data.uuid) {
            Object.assign(this.form, data)
          } else {
            Object.assign(this.form, this.baseForm)
          }
        }
      })
    },
    async confirmHandler() {
      const form = this.form
      const loading = getLoading4Cxt(this)
      await saveRateCacheRange(form).then(async res => {
        if (res.ok) {
          this.$message.success(this.$t('Message.SaveSuccessfully'))
        } else {
          this.$message.error(this.$t('Message.SaveFailed'))
        }
        await this.$store.dispatch('settings/changeSetting', { key: 'rateCacheRange', value: form.monthRange })
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRate)
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRatePeriod)
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRateBranch)
      }).finally(() => {
        loading.close()
      })
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
